import { createReducer, on } from "@ngrx/store";
import { Action } from "rxjs/internal/scheduler/Action";
import { Building } from "src/components/shared-components/class/general-classes/building";
import { BIGDeviceOperationMode } from "src/components/shared-components/enum/enumDevice";
import {
  currentBuildingChangeConnectionAddressAction,
  currentBuildingChangeDefaultSupervisionToOpenAction,
  currentBuildingChangeSelectionAction,
  currentBuildingChangeWanConnectionAction,
  currentBuildingUnsetAction,
  buildingAddAction,
  buildingChangeWanAllowConnectionAction,
  buildingOverwriteAction,
  buildingRemoveAction,
  buildingUpdateAction,
} from "../actions/building.action";

//#region building list
/**
 * Reducer plant creation
 */

/**
 * Memeber exportfor authentication reducer
 *
 * @param action
 * @param state
 * @returns
 */
export const BuildingsReducer = createReducer(
  [],
  on(buildingAddAction, (listBuilding: Array<Building>, action) => {
    return [...listBuilding, action.newBuilding];
  }),
  on(buildingRemoveAction, (listBuilding: Array<Building>, action) => {
    return listBuilding.filter(
      (building: Building) => building.id !== action.idBuilding
    );
  }),
  on(buildingUpdateAction, (listBuilding: Array<Building>, action) => {
    return listBuilding.map((building: Building) => {
      if (building.id === action.updateBuilding.id) {
        building = action.updateBuilding;
      }

      return building;
    });
  }),
  on(buildingOverwriteAction, (listBuilding: Array<Building>, action) => {
    return action.updateBuildings;
  })
);
//#endregion

/**
 * Current plant reducer
 *
 * @param action
 * @param state
 * @returns
 */
export const CurrentBuildingReducer = createReducer(
  null,
  on(
    currentBuildingChangeSelectionAction,
    (selectedBuilding: Building, action) => {
      const building: Building = new Building(action.selectedBuilding);
      building.default = action.defaultBuilding;

      return { ...building };
    }
  ),
  on(currentBuildingUnsetAction, (selectedBuilding: Building, action) => {
    return null;
  }),
  on(
    currentBuildingChangeConnectionAddressAction,
    (selectedBuilding: Building, action) => {
      let currentSelectedBuilding: Building = new Building({
        ...selectedBuilding,
      });

      return {
        ...currentSelectedBuilding,
        Endpoint: action.newAddressConnection,
      };
    }
  ),

  on(
    currentBuildingChangeDefaultSupervisionToOpenAction,
    (selectedBuilding: Building, action) => {
      const defaultSupervisionToOpen: string =
        action.idSupervision.toString() + "," + action.idEnvironment.toString();

      return {
        ...selectedBuilding,
        defaultSupervision: defaultSupervisionToOpen,
      };
    }
  )
);
